import { render, staticRenderFns } from "./BinaryDataDisplayEmbed.vue?vue&type=template&id=db0017d0&"
import script from "./BinaryDataDisplayEmbed.vue?vue&type=script&lang=ts&"
export * from "./BinaryDataDisplayEmbed.vue?vue&type=script&lang=ts&"
import style0 from "./BinaryDataDisplayEmbed.vue?vue&type=style&index=0&id=db0017d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports